function initBuyButtons() {
  const seriesSelect = document.querySelector('select[name="options[Series]"]');
  const topPlateTypeSelect = document.querySelector(
    'select[name="options[Top Plate Type]"]',
  );
  const customSpringRate = document.getElementById("custom-spring-rate");
  const frontSpringRates = document.getElementById("front-spring-rates");
  const rearSpringRates = document.getElementById("rear-spring-rates");
  const swiftFrontSpringRates = document.getElementById(
    "swift-front-spring-rates",
  );
  const swiftRearSpringRates = document.getElementById(
    "swift-rear-spring-rates",
  );
  const frontLabel = document.getElementById("frontlabel");
  const rearLabel = document.getElementById("rearlabel");
  const buildlabel = document.getElementById("buildlabel");
  const frontlabelswift = document.getElementById("frontlabelswift");
  const rearlabelswift = document.getElementById("rearlabelswift");
  let swiftSelectElement;
  let extremeLowSelectElement;
  let extremeLowFrontOnly = false;
  let isEligibleForDiscount = false;
  let _kitInitTries = 0;
  let optionsReady = false;
  let overlay = null;

  // Bold uses jQuery internally — dispatch through jQuery when available
  // so Bold's handlers see the change, then also fire a native event for
  // any vanilla listeners
  function triggerChange(el) {
    if (!el) return;
    if (window.jQuery) {
      window.jQuery(el).trigger("change");
    }
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function createOverlay() {
    const productInfo = document.querySelector("product-info");
    if (!productInfo) return null;

    productInfo.style.position = "relative";

    const el = document.createElement("div");
    el.id = "options-loading-overlay";
    el.style.cssText =
      "position:absolute;inset:0;background:rgba(255,255,255,0.7);" +
      "z-index:10;display:flex;align-items:center;justify-content:center;" +
      "transition:opacity 0.3s ease;pointer-events:all;";

    const spinner = document.createElement("div");
    spinner.classList.add("loading__spinner");
    spinner.innerHTML =
      '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
      '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';

    el.appendChild(spinner);
    productInfo.appendChild(el);
    return el;
  }

  function lockForm() {
    overlay = createOverlay();
  }

  function unlockForm() {
    if (optionsReady) return;
    optionsReady = true;

    if (overlay) {
      overlay.style.opacity = "0";
      overlay.style.pointerEvents = "none";
      setTimeout(function () {
        overlay.remove();
      }, 300);
    }

    // Bold's clone blocks form submission when its internal validation
    // fails (disabled selects look like unfilled required fields).
    // Hide the clone and restore the original button so the native
    // form submit path works.
    restoreOriginalButton();

    // Form is ready — overlay removed, original button restored
  }

  function openTopPlateConfiguration() {
    const targetId = "topplatedata";
    const desktopTab = document.querySelector(
      `.tabs-nav-button[data-target="${targetId}"]`,
    );
    const targetPanel = document.getElementById(targetId);
    const accordionButton =
      targetPanel && targetPanel.previousElementSibling
        ? targetPanel.previousElementSibling
        : document.getElementById("topplateconfiguration");
    let scrollTarget = targetPanel;

    if (window.innerWidth >= 768 && desktopTab) {
      desktopTab.click();
      scrollTarget = desktopTab;
    } else if (
      accordionButton &&
      !accordionButton.classList.contains("active")
    ) {
      accordionButton.click();
      scrollTarget = accordionButton;
    } else if (accordionButton) {
      scrollTarget = accordionButton;
    }

    if (scrollTarget) {
      scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  function addSelectLabelIcon(select, className, labelText, onClick) {
    if (!select) return false;

    const wrapper = select.closest(".product-form__input, .bold_option");
    if (!wrapper || wrapper.querySelector(`.${className}`)) return false;

    const label = wrapper.querySelector(".form__label, .bold_option_title");
    if (!label) return;

    const icon = document.createElement("button");
    icon.type = "button";
    icon.className = `select-label-info-link ${className}`;
    icon.setAttribute("aria-label", labelText);
    icon.title = labelText;
    icon.innerHTML = '<span aria-hidden="true">i</span>';
    icon.addEventListener("click", onClick);

    label.classList.add("form__label--with-info");
    label.appendChild(icon);

    return true;
  }

  function findSelectByLabelText(labelText) {
    const normalizedLabelText = labelText.toLowerCase();
    const labels = document.querySelectorAll(".form__label, .bold_option_title");

    for (let index = 0; index < labels.length; index++) {
      const label = labels[index];
      const text = label.textContent.trim().toLowerCase();
      if (!text.includes(normalizedLabelText)) continue;

      const wrapper = label.closest(".product-form__input, .bold_option");
      const select = wrapper ? wrapper.querySelector("select") : null;
      if (select) return select;
    }

    return null;
  }

  function getSelectLabelText(select) {
    const wrapper = select.closest(".product-form__input, .bold_option");
    const label = wrapper
      ? wrapper.querySelector(".form__label, .bold_option_title")
      : null;

    return label ? label.textContent.trim() : "";
  }

  function selectHasOptionText(select, searchText) {
    const normalizedSearchText = searchText.toLowerCase();
    return Array.from(select.options).some((option) =>
      option.textContent.toLowerCase().includes(normalizedSearchText),
    );
  }

  function findSelectByNameLabelOrOptionText(searchText) {
    const normalizedSearchText = searchText.toLowerCase();
    const selects = document.querySelectorAll("select");

    for (let index = 0; index < selects.length; index++) {
      const select = selects[index];
      const name = select.name.toLowerCase();
      const label = getSelectLabelText(select).toLowerCase();

      if (
        name.includes(normalizedSearchText) ||
        label.includes(normalizedSearchText) ||
        selectHasOptionText(select, normalizedSearchText)
      ) {
        return select;
      }
    }

    return null;
  }

  function findSpindleLengthSelect() {
    return (
      document.querySelector(
        'select[name="options[Spindle Configuration]"], select[name="options[Spindle Length]"], select[name="properties[Spindle Configuration]"], select[name="properties[Spindle Length]"]',
      ) ||
      findSelectByLabelText("spindle length") ||
      findSelectByLabelText("spindle configuration") ||
      findSelectByNameLabelOrOptionText("spindle")
    );
  }

  function addTopPlateConfigurationLink() {
    addSelectLabelIcon(
      topPlateTypeSelect,
      "top-plate-config-link",
      "Learn more about top plate configuration",
      openTopPlateConfiguration,
    );
  }

  function addSpindleLengthGuideLink() {
    const added = addSelectLabelIcon(
      findSpindleLengthSelect(),
      "spindle-length-guide-link",
      "Open spindle length measurement guide",
      function () {
        window.open(
          "https://shop.bcracing-na.com/pages/spindle-length",
          "_blank",
          "noopener",
        );
      },
    );

    const standaloneLink = document.querySelector(".spindle-link");
    if (added && standaloneLink) standaloneLink.style.display = "none";

    return added;
  }

  function waitForSpindleLengthGuideLink() {
    let attempts = 0;
    const interval = setInterval(function () {
      attempts++;
      if (addSpindleLengthGuideLink() || attempts >= 25) {
        clearInterval(interval);
      }
    }, 200);
  }

  function restoreOriginalButton() {
    var original = document.querySelector(
      ".product-form__submit:not(.bold_clone)",
    );
    var clone = document.querySelector("button.bold_clone");
    var productFormEl = document.querySelector("product-form");

    // Hide Bold's clone
    if (clone) clone.style.display = "none";

    if (original) {
      // cloneNode(true) copies the DOM but NOT event listeners —
      // this strips Bold's click handler that blocks form submission
      var clean = original.cloneNode(true);
      clean.classList.remove("bold_hidden");
      clean.style.cssText = "";
      clean.disabled = false;
      clean.removeAttribute("aria-disabled");
      clean.removeAttribute("data-bc-locked");
      original.parentNode.replaceChild(clean, original);

      // Update product-form's reference so its submit handler
      // targets the new button for loading state / aria
      if (productFormEl) productFormEl.submitButton = clean;
    }
  }

  lockForm();
  addTopPlateConfigurationLink();
  waitForSpindleLengthGuideLink();

  const defaultValues = {
    "Optional Front Caster": "None",
    "Optional Rear Camber": "None",
    "Swift Springs": "None",
    "Extreme Low": "No, Extreme Low",
    "Extreme Low Front Only": "No, Extreme Low",
    "Rear Top Plate Upgrade": "Reuse OEM",
    "Spring Rate Type": "default",
    "Top Plate": "On Center",
  };

  function hideElement(el) {
    if (el) {
      el.style.display = "none";
      el.classList.add("custom_hidden");
      el.disabled = true;
    }
  }

  function showElement(el) {
    if (el) {
      el.style.display = "";
      el.classList.remove("custom_hidden");
      el.disabled = false;
    }
  }

  function findKitCheckbox() {
    const options = document.querySelectorAll(".bold_option_set .bold_option");
    for (let i = 0; i < options.length; i++) {
      const titleEl = options[i].querySelector(".bold_option_title");
      if (titleEl && titleEl.textContent.trim() === "Customize Kit") {
        return options[i].querySelector('input[type="checkbox"]');
      }
    }
    return null;
  }

  function hideSwiftSpringsInit() {
    hideElement(swiftFrontSpringRates);
    hideElement(swiftRearSpringRates);
    hideElement(frontlabelswift);
    hideElement(rearlabelswift);
  }

  function hideRegularSprings() {
    hideElement(frontSpringRates);
    hideElement(rearSpringRates);
    hideElement(frontLabel);
    hideElement(rearLabel);
  }

  function showRegularSprings() {
    showElement(frontSpringRates);
    showElement(rearSpringRates);
    showElement(frontLabel);
    showElement(rearLabel);
  }

  function hideSwiftSprings() {
    if (frontSpringRates) {
      showElement(frontSpringRates);
      hideElement(frontlabelswift);
      hideElement(swiftFrontSpringRates);
    }
    if (rearSpringRates) {
      showElement(rearSpringRates);
      hideElement(rearlabelswift);
      hideElement(swiftRearSpringRates);
    }
  }

  function showSwiftSprings() {
    if (swiftFrontSpringRates) {
      hideElement(frontSpringRates);
      hideElement(frontLabel);
      showElement(frontlabelswift);
      showElement(swiftFrontSpringRates);
    } else {
      showElement(frontSpringRates);
      showElement(frontLabel);
      hideElement(frontlabelswift);
      hideElement(swiftFrontSpringRates);
    }
    if (swiftRearSpringRates) {
      hideElement(rearSpringRates);
      hideElement(rearLabel);
      showElement(rearlabelswift);
      showElement(swiftRearSpringRates);
    } else {
      showElement(rearSpringRates);
      showElement(rearLabel);
      hideElement(rearlabelswift);
      hideElement(swiftRearSpringRates);
    }
  }

  function zrseriesselected() {
    const kitCheckbox = findKitCheckbox();
    if (kitCheckbox) {
      if (kitCheckbox.checked) {
        hideElement(customSpringRate);
        hideElement(buildlabel);
        showSwiftSprings();
      }
    } else {
      hideElement(customSpringRate);
      hideElement(buildlabel);
      showSwiftSprings();
    }
  }

  function zrseriesunselected() {
    showElement(customSpringRate);
    showElement(buildlabel);
    hideSwiftSpringsInit();
    hideRegularSprings();
  }

  function setBoldSwiftSpringsHidden(hidden) {
    const el =
      swiftSelectElement ||
      document.querySelector('select[name="properties[Swift Springs]"]');

    if (!el) return;

    const wrapper = el.closest(".bold_option");

    if (hidden) {
      el.value = "None";
      triggerChange(el);
    }

    el.disabled = hidden;
    if (wrapper) wrapper.style.display = hidden ? "none" : "";
  }

  function hideExtremeLow() {
    var el =
      extremeLowSelectElement ||
      document.querySelector('select[name^="properties[Extreme Low"]');
    if (el) {
      el.disabled = true;
      el.value = "No, Extreme Low";
    }
    applyDefaultRates();
  }

  function showExtremeLow() {
    setTimeout(function () {
      var el =
        extremeLowSelectElement ||
        document.querySelector('select[name^="properties[Extreme Low"]');
      if (el) el.disabled = false;
    }, 750);
  }

  function seriesSwitch(series) {
    setBoldSwiftSpringsHidden(
      series === "HM-SERIES" ||
        series === "ZR-SERIES" ||
        series === "ZX-SERIES",
    );

    switch (series) {
      case "BR-SERIES":
      case "DS-SERIES":
        showExtremeLow();
        zrseriesunselected();
        break;
      case "ER-SERIES":
      case "RM-SERIES":
        hideExtremeLow();
        zrseriesunselected();
        break;
      case "HM-SERIES":
      case "ZR-SERIES":
      case "ZX-SERIES":
        hideExtremeLow();
        zrseriesselected();
        break;
      default:
        console.warn("Unknown series selected.");
        break;
    }
  }

  function checkCustomization() {
    const productCustomized = document.getElementById("product-customized");
    if (!productCustomized) return;

    if (!isEligibleForDiscount) {
      productCustomized.value = "true";
      return;
    }

    let isCustomized = false;
    for (const property in defaultValues) {
      const select = document.querySelector(
        `select[name="properties[${property}]"]`,
      );
      if (
        select &&
        select.value.toLowerCase() !== defaultValues[property].toLowerCase() &&
        select.value !== ""
      ) {
        isCustomized = true;
        break;
      }
    }
    productCustomized.value = isCustomized ? "true" : "false";
  }

  function initialSeriesCheck() {
    if (!seriesSelect) return;
    const seriesValue = seriesSelect.value;

    if (seriesValue === "BR-SERIES" || seriesValue === "DS-SERIES") {
      isEligibleForDiscount = true;
      checkCustomization();
    } else {
      isEligibleForDiscount = false;
      const productCustomized = document.getElementById("product-customized");
      if (productCustomized) productCustomized.value = "true";
    }
  }

  function setNativeOptionSelectLocked(select, locked) {
    if (!select) return;

    select.disabled = locked;
    select.style.opacity = locked ? "0.3" : "1";
  }

  function handleKitCheckboxToggle(kitCheckbox) {
    const customWrapper = document.querySelector(
      "p.line-item-property__field.build-type",
    );
    if (customWrapper) {
      customWrapper.style.display = kitCheckbox.checked ? "" : "none";
    }
    if (kitCheckbox.checked) {
      const series = seriesSelect ? seriesSelect.value : "";
      setNativeOptionSelectLocked(seriesSelect, true);
      setNativeOptionSelectLocked(topPlateTypeSelect, true);
      seriesSwitch(series);
      if (
        swiftSelectElement &&
        swiftSelectElement.value === "Yes, Swift Springs"
      ) {
        hideElement(buildlabel);
        hideElement(customSpringRate);
        showSwiftSprings();
      }
      if (
        extremeLowSelectElement &&
        extremeLowSelectElement.value === "Yes, Extreme Low"
      ) {
        applyExtremeLowRates();
      }
      if (customSpringRate) customSpringRate.disabled = false;
    } else {
      setNativeOptionSelectLocked(seriesSelect, false);
      setNativeOptionSelectLocked(topPlateTypeSelect, false);
      hideSwiftSprings();
      hideRegularSprings();
      if (customSpringRate) {
        customSpringRate.value = "default";
        customSpringRate.disabled = true;
        handleCustomSpringRateChange();
      }
    }
  }

  function initCustomizeKit() {
    const kitCheckbox = findKitCheckbox();

    if (kitCheckbox) {
      // Set correct initial state — disables our line-item selects when
      // the kit checkbox starts unchecked so they don't submit to the cart
      handleKitCheckboxToggle(kitCheckbox);

      // Listen for change (covers click, keyboard spacebar, and programmatic changes)
      kitCheckbox.addEventListener("change", function () {
        handleKitCheckboxToggle(this);
      });

      // Some third-party apps toggle checked without firing change — observe the attribute
      const checkboxObserver = new MutationObserver(function () {
        handleKitCheckboxToggle(kitCheckbox);
      });
      checkboxObserver.observe(kitCheckbox, {
        attributes: true,
        attributeFilter: ["checked"],
      });

      // Also listen for click as a fallback for keyboard activation on custom checkboxes
      kitCheckbox.addEventListener("click", function () {
        // Defer to let the checked state settle
        requestAnimationFrame(() => handleKitCheckboxToggle(this));
      });

      unlockForm();
    } else if (_kitInitTries < 25) {
      _kitInitTries++;
      setTimeout(initCustomizeKit, 200);
    } else {
      // Bold options never loaded — unlock form anyway so non-customizable products can be purchased
      unlockForm();
    }
  }

  function handleCustomSpringRateChange() {
    if (customSpringRate && customSpringRate.value === "custom") {
      showElement(frontSpringRates);
      showElement(rearSpringRates);
      showElement(frontLabel);
      showElement(rearLabel);
    } else {
      hideElement(frontSpringRates);
      hideElement(rearSpringRates);
      hideElement(frontLabel);
      hideElement(rearLabel);
      if (frontSpringRates) frontSpringRates.selectedIndex = 0;
      if (rearSpringRates) rearSpringRates.selectedIndex = 0;
    }
  }

  // Series change handler
  if (seriesSelect) {
    seriesSelect.addEventListener("change", function () {
      const seriesValue = this.value;
      if (seriesValue === "BR-SERIES" || seriesValue === "DS-SERIES") {
        // eligible
      } else {
        isEligibleForDiscount = false;
      }
    });
  }

  // Product customized change handler
  const productCustomizedEl = document.getElementById("product-customized");
  if (productCustomizedEl) {
    productCustomizedEl.addEventListener("change", function () {
      initialSeriesCheck();
    });
  }

  // MutationObserver for bold property selects
  const propertyObserver = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      for (const property in defaultValues) {
        const select = document.querySelector(
          `select[name="properties[${property}]"]`,
        );
        if (select && !select.dataset.listenerAdded) {
          select.addEventListener("change", checkCustomization);
          select.dataset.listenerAdded = "true";
        }
      }
    });
  });

  propertyObserver.observe(document.body, { childList: true, subtree: true });
  initialSeriesCheck();

  window.addEventListener("unload", function () {
    propertyObserver.disconnect();
  });

  // Hide spring rate options immediately to prevent flash before Bold loads
  hideSwiftSpringsInit();
  // Disable our line-item selects immediately so they never submit before
  // the kit checkbox state is evaluated in initCustomizeKit
  if (customSpringRate) customSpringRate.disabled = true;
  hideRegularSprings();
  // Hide the build-type wrapper until customize kit is checked
  const buildTypeWrapper = document.querySelector(
    "p.line-item-property__field.build-type",
  );
  if (buildTypeWrapper) buildTypeWrapper.style.display = "none";

  // Poll for series select to appear — once found, run series logic and unlock the form
  const checkInterval = setInterval(function () {
    const currentSeriesSelect = document.querySelector(
      'select[name="options[Series]"]',
    );
    if (!currentSeriesSelect) return;

    seriesSwitch(currentSeriesSelect.value);

    currentSeriesSelect.addEventListener("change", function () {
      seriesSwitch(this.value);
    });

    clearInterval(checkInterval);
    clearTimeout(checkTimeout);
    unlockForm();
  }, 1000);

  const checkTimeout = setTimeout(function () {
    clearInterval(checkInterval);
    // Timed out waiting — unlock anyway so users aren't permanently blocked
    unlockForm();
  }, 3500);

  // Poll for properties[Series] bold select to appear
  const checkIntervalOptions = setInterval(function () {
    const propertiesSeriesSelect = document.querySelector(
      'select[name="properties[Series]"]',
    );
    if (propertiesSeriesSelect) {
      const nativeSelect = document.querySelector(
        'select[name="options[Series]"]',
      );

      propertiesSeriesSelect.disabled = true;

      if (nativeSelect) {
        propertiesSeriesSelect.value = nativeSelect.value;
        triggerChange(propertiesSeriesSelect);

        nativeSelect.addEventListener("change", function () {
          propertiesSeriesSelect.value = nativeSelect.value;
          triggerChange(propertiesSeriesSelect);
        });
      }

      clearInterval(checkIntervalOptions);
      clearTimeout(timeoutOptions);
    }
  }, 1000);

  const timeoutOptions = setTimeout(function () {
    clearInterval(checkIntervalOptions);
  }, 3500);

  // Swift Springs MutationObserver
  function findSwiftSelectElement() {
    swiftSelectElement = document.querySelector(
      'select[name="properties[Swift Springs]"]',
    );
    if (swiftSelectElement) {
      swiftObserver.disconnect();
      swiftSelectElement.addEventListener(
        "change",
        handleSwiftSpringRateChange,
      );
      if (seriesSelect) {
        setBoldSwiftSpringsHidden(
          seriesSelect.value === "HM-SERIES" ||
            seriesSelect.value === "ZR-SERIES" ||
            seriesSelect.value === "ZX-SERIES",
        );
      }
    }
  }

  const swiftObserver = new MutationObserver(findSwiftSelectElement);
  swiftObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  findSwiftSelectElement();

  function handleSwiftSpringRateChange() {
    if (
      swiftSelectElement &&
      swiftSelectElement.value === "Yes, Swift Springs"
    ) {
      hideElement(buildlabel);
      hideElement(customSpringRate);
      showSwiftSprings();
    } else {
      resetBuildToDefault();
      hideAllSprings();
    }
  }

  function resetBuildToDefault() {
    showElement(customSpringRate);
    showElement(buildlabel);
    if (customSpringRate) customSpringRate.value = "default";
  }

  function hideAllSprings() {
    hideElement(frontLabel);
    hideElement(rearLabel);
    hideElement(frontSpringRates);
    hideElement(rearSpringRates);
    hideElement(frontlabelswift);
    hideElement(rearlabelswift);
    hideElement(swiftFrontSpringRates);
    hideElement(swiftRearSpringRates);
  }

  // Extreme Low — swap spring rate options between default and extreme low
  function repopulateSelect(selectEl, ratesString) {
    if (!selectEl || !ratesString) return;
    var rates = ratesString.split(", ");
    selectEl.innerHTML = "";
    for (var i = 0; i < rates.length; i++) {
      var opt = document.createElement("option");
      opt.value = rates[i];
      opt.textContent = rates[i];
      selectEl.appendChild(opt);
    }
  }

  function applyExtremeLowRates() {
    var selects = [
      frontSpringRates,
      rearSpringRates,
      swiftFrontSpringRates,
      swiftRearSpringRates,
    ];
    for (var i = 0; i < selects.length; i++) {
      if (selects[i] && selects[i].dataset.extremeRates) {
        repopulateSelect(selects[i], selects[i].dataset.extremeRates);
      }
    }
  }

  function applyDefaultRates() {
    var selects = [
      frontSpringRates,
      rearSpringRates,
      swiftFrontSpringRates,
      swiftRearSpringRates,
    ];
    for (var i = 0; i < selects.length; i++) {
      if (selects[i] && selects[i].dataset.defaultRates) {
        repopulateSelect(selects[i], selects[i].dataset.defaultRates);
      }
    }
  }

  function handleExtremeLowChange() {
    if (
      extremeLowSelectElement &&
      extremeLowSelectElement.value === "Yes, Extreme Low"
    ) {
      applyExtremeLowRates();
    } else {
      applyDefaultRates();
    }
  }

  function findExtremeLowSelectElement() {
    extremeLowSelectElement = document.querySelector(
      'select[name^="properties[Extreme Low"]',
    );
    if (extremeLowSelectElement) {
      extremeLowFrontOnly =
        extremeLowSelectElement.name === "properties[Extreme Low Front Only]";
      extremeLowObserver.disconnect();
      extremeLowSelectElement.addEventListener(
        "change",
        handleExtremeLowChange,
      );
    }
  }

  var extremeLowObserver = new MutationObserver(findExtremeLowSelectElement);
  extremeLowObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  findExtremeLowSelectElement();

  // Initial state for custom spring rate
  handleCustomSpringRateChange();
  if (customSpringRate) {
    customSpringRate.addEventListener("change", handleCustomSpringRateChange);
  }

  // Init customize kit after delay for Bold options to load
  setTimeout(initCustomizeKit, 1500);

  // Absolute safety net — unlock after 5s no matter what
  setTimeout(function () {
    unlockForm();
  }, 5000);
}

// Run init whether DOMContentLoaded already fired or not
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBuyButtons);
} else {
  initBuyButtons();
}
